
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 108 108"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 3.997C6 .934 9.317-.987 11.986.53l87.993 50.003c2.695 1.53 2.695 5.403 0 6.934L11.986 107.47C9.316 108.987 6 107.065 6 104.003V3.997z"}})])
          )
        }
      }
    